import { useEffect, useState } from 'react';
import RewardList from '../Components/Rewards/RewardList';
import AddReward from '../Components/Rewards/AddReward';
import Header from '../Components/Header';
import API from '../Services/api';

function RewardsPage() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'admin') setIsAdmin(true);

    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
      API.get('/users/profile')
        .then(({ data }) => setUser(data))
        .catch(() => {});
    }
  }, []);

  const totalPoints = (user?.recyclingHistory || []).reduce((sum, e) => sum + (e.pointsEarned || 0), 0);

  return (
    <div className="min-h-screen bg-[#F8FAFB] flex flex-col">
      <Header isDashboard={false} isAuthenticated={isAuthenticated} user={user} />

      {/* Hero Banner */}
      <div className="bg-[#004d3f] text-white py-10 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          {/* Back button */}
          <a
            href={isAuthenticated ? "/profile" : "/"}
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white mb-6 transition"
          >
            ← {isAuthenticated ? "Back to Dashboard" : "Back to Home"}
          </a>

          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-white/15 rounded-xl flex items-center justify-center">
              <i className="fas fa-gift text-white text-lg"></i>
            </div>
            <span className="text-green-300 text-xs font-semibold uppercase tracking-widest">e-save Rewards</span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-2">Rewards Catalogue</h1>
          <p className="text-green-100 text-base max-w-xl leading-relaxed">
            Earn points every time you recycle your old electronics and redeem them for eco vouchers, partner discounts, and green experiences.
          </p>

          {isAuthenticated && (
            <div className="mt-6 inline-flex items-center gap-3 bg-white/10 rounded-2xl px-5 py-3">
              <i className="fas fa-coins text-yellow-300 text-lg"></i>
              <div>
                <p className="text-xs text-green-200">Your balance</p>
                <p className="text-xl font-bold">{totalPoints} <span className="text-sm font-normal text-green-200">pts</span></p>
              </div>
            </div>
          )}

          <div className="flex flex-wrap gap-4 mt-6">
            <div className="flex items-center gap-2 text-sm text-green-200">
              <i className="fas fa-check-circle text-green-400 text-xs"></i>
              Points never expire
            </div>
            <div className="flex items-center gap-2 text-sm text-green-200">
              <i className="fas fa-check-circle text-green-400 text-xs"></i>
              Eco vouchers &amp; discounts
            </div>
            <div className="flex items-center gap-2 text-sm text-green-200">
              <i className="fas fa-check-circle text-green-400 text-xs"></i>
              No cash payments
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 py-8">
        {isAdmin && (
          <div className="mb-8">
            <button
              onClick={() => setShowAddForm(!showAddForm)}
              className="flex items-center gap-2 bg-[#004d3f] text-white px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-[#003d32] transition shadow-sm"
            >
              <i className={`fas fa-${showAddForm ? 'times' : 'plus'}`}></i>
              {showAddForm ? 'Cancel' : 'Add Reward'}
            </button>
            {showAddForm && (
              <div className="mt-6">
                <AddReward onSuccess={() => setShowAddForm(false)} />
              </div>
            )}
          </div>
        )}

        <RewardList userPoints={totalPoints} />
      </div>
    </div>
  );
}

export default RewardsPage;
